import { useContext } from "react";

import { CartContext } from "../components/cart/CartProvider";

const useCart = () => useContext(CartContext);

export default useCart;
